// Mirrors backend ROLE_PERMISSIONS. Server is the source of truth; this only shapes the UI.
export const ROLES = ["admin", "editor", "approver", "viewer", "no_access"];

export const ROLE_PERMISSIONS = {
  admin: [
    "data:read", "clients:write", "clients:delete", "deals:write", "activities:write",
    "activities:delete", "deals:stage", "deals:approve", "deals:assign_pic", "deals:delete",
    "comments:write", "progress:write", "users:manage", "audit:read",
  ],
  editor: [
    "data:read", "clients:write", "deals:write", "activities:write",
    "deals:stage_request", "comments:write", "progress:write",
  ],
  approver: [
    "data:read", "deals:approve", "deals:assign_pic", "deals:delete",
    "clients:delete", "activities:delete", "comments:write", "progress:write", "audit:read",
  ],
  viewer: ["data:read"],
  no_access: [],
};

export const ROLE_BADGE = {
  admin: "bg-orange-50 text-orange-700 border-orange-200",
  editor: "bg-sky-50 text-sky-700 border-sky-200",
  approver: "bg-violet-50 text-violet-700 border-violet-200",
  viewer: "bg-slate-100 text-slate-600 border-slate-200",
  no_access: "bg-rose-50 text-rose-700 border-rose-200",
};

export const permsOf = (user) =>
  user?.permissions || ROLE_PERMISSIONS[user?.role] || [];

// Deletion is restricted to an admin or the person responsible for the record
// (deal PIC, or the creator for clients/activities). Mirrors can_delete_record() on the server.
export const canDeleteRecord = (user, record, ownerField) =>
  !!user && !!record && (user.role === "admin" || record[ownerField] === user.user_id);
